var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63992 3.42501C5.71018 3.36639 5.8055 3.33342 5.90492 3.33335L6.09492 3.33335C6.19413 3.33431 6.28906 3.36714 6.35992 3.42501L8.92491 5.56668C8.97224 5.6058 8.99886 5.65905 8.99886 5.7146C8.99886 5.77015 8.97224 5.82339 8.92491 5.86251L8.56991 6.15835C8.52383 6.19754 8.46076 6.21963 8.39491 6.21963C8.32907 6.21963 8.266 6.19754 8.21991 6.15835L5.99992 4.30418L3.77992 6.15835C3.73298 6.19779 3.66908 6.21997 3.60242 6.21997C3.53577 6.21997 3.47187 6.19779 3.42493 6.15835L3.07493 5.86251C3.0276 5.82339 3.00098 5.77015 3.00098 5.7146C3.00098 5.65905 3.0276 5.6058 3.07493 5.56668L5.63992 3.42501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsc);
export default __webpack_public_path__ + "static/media/Asc.eed35dd9.svg";
export { ForwardRef as ReactComponent };